/** @format */

import styled from 'styled-components';

export const Wrapper = styled.div`
  font-size: 0.875rem;
  color: #333;
  display: flex;
  flex-wrap: wrap;
  gap: clamp(0.5rem, -2.2692rem + 12.3077vw, 1rem);
`;

export const BaseDetails = styled.div`
  display: flex;
  gap: 0.25rem;
  align-items: center;

  span {
    color: var(--gray-900);
    font-family: ${({ theme }) => theme.font.body};
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.25rem;
  }
`;

export const RoomType = styled(BaseDetails)``;
export const RoomSize = styled(BaseDetails)``;
export const Bathroom = styled(BaseDetails)``;
